import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/membros/primeiros-clientes")({
  head: () => ({ meta: [{ title: "Primeiros clientes — Projeto 101" }, { name: "robots", content: "noindex, nofollow" }] }),
  component: FirstClientsPage,
});

const blocks = [
  { t: "1. Rede próxima primeiro", d: "Liste 20 pessoas que confiam em você e pergunte se conhecem alguém que precise do serviço." },
  { t: "2. Prova real, não promessa", d: "Ofereça de 3 a 5 atendimentos com preço de portfólio em troca de foto, depoimento e indicação." },
  { t: "3. Um canal, feito bem", d: "Escolha um canal (Instagram, panfleto, grupo de bairro) e domine antes de abrir mais frentes." },
  { t: "4. Follow-up simples", d: "Todo cliente atendido recebe uma mensagem 3 dias depois pedindo indicação." },
  { t: "5. Parcerias locais", d: "Aproxime-se de negócios que já falam com o seu cliente ideal." },
];

function FirstClientsPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="font-display text-3xl font-extrabold">Guia dos primeiros clientes</h1>
        <p className="mt-1 text-sm text-[var(--gray-ink)]">
          Cinco frentes práticas para conseguir os primeiros clientes com pouco ou nenhum investimento.{" "}
          <em>[Conteúdo demonstrativo — versão final em breve.]</em>
        </p>
      </div>
      <div className="space-y-3">
        {blocks.map((b) => (
          <div key={b.t} className="rounded-2xl border border-black/5 bg-white p-5">
            <h3 className="font-display text-lg font-extrabold">{b.t}</h3>
            <p className="mt-1 text-sm text-[var(--gray-ink)]">{b.d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
